import * as React from "react";
import { config } from "../../../../src/config";
// import * as R from "ramda";

import { observable } from "mobx";
import { observer } from "mobx-react";

import {
  Button,
  Typography,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Input,
} from "@material-ui/core";
import { MaterialTextField } from "../../../../src/components/text-field";

import { IAPIResponse } from "../../../../src/shared/api-response";
import { checkAuthStore, authStore } from "../../../../src/modules/auth/store";
import "./style.css";

import { withRouter } from "react-router";
import { AlertBar } from "../../../components/alert-bar";

const styles = createStyles({});

@observer
class LoginForm extends React.Component<any> {
  @observable public email: string;
  @observable public password: string;
  @observable public passwordResetEmail: string;
  @observable public verifyOtpFromMail: string; // E-001 TMPS > 2 Step Verification
  @observable public error: boolean = false;
  @observable public redirect: boolean = false;
  @observable public logInUserName: string; // E-001 TMPS > 2 Step Verification
  @observable public reverseCount: number = 60; // E-066
  @observable public cpyReverseCount: any;// E-066
  @observable public isSuccessAlert: boolean = false; // E-066
  @observable public isMatched: boolean = false; // E-066
  @observable public combinationError: boolean = false; // E-066


  public state = {
    dialogOpen: false,
    afterRequestDialogOpen: false,
    otpDialogOpen: false,
    enableVerifyBtn: true,
  }; // E-001 TMPS > 2 Step Verification

  constructor(props: any) {
    super(props);
  }

  /**
   * handleChange
   */
  public handleChange = (x: string) => (e: React.ChangeEvent, v: string) => {
    this[x] = v;
  };

  /**
   * E-001 handlechange whilte enterd the otp on input field, apply condition to take only 6 digit and verify button must be in disabled
   * @param e
   */
  public handlOtpChange = (e: any) => {
    let value = e.target.value.slice(0, 6)
      this.verifyOtpFromMail = value
      if(value.length >= 6) {
        this.setState({enableVerifyBtn: false})
      }
      else {
        this.setState({enableVerifyBtn: true})
    }
  };

  /**
   * handleLogin
   * E-001 modifying the handleloging function while added 2 step verification functionality
   */

  // E-066
  public CountFun = () => {
    const interval = setInterval(() => {
      this.reverseCount = this.reverseCount - 1;
      if (this.reverseCount === 0) {
        clearInterval(interval);
      }
    }, 1000);
    this.cpyReverseCount = interval;
  };

  public handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/login",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          Email: this.email,
          Password: this.password,
        }),
      }
    );
    const result: IAPIResponse = await response.json();
    if (result.success && result.body) {
      this.CountFun(); // E-066
      this.logInUserName = this.email;
      this.setState({ otpDialogOpen: true });
      this.error = false; // E-066
    } else {
      this.error = true;
      this.combinationError = true // E-066
    }
    // E-066
    if(this.combinationError== true){
      setTimeout(() => {
        this.combinationError =  false;
      }, 3000);
     }
  };

  public handleTokenRequest = async () => {
    const res = await authStore.requestPasswordToken(this.passwordResetEmail);
    this.setState({ dialogOpen: false })
    this.setState({ afterRequestDialogOpen: true })
  };

  /**
   * #TODO E-001 TMPS > 2 Step Verification
   */
  public handleVerifyOtpToLogin = async () => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/verifyOtp",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          Email: this.email,
          Verify_OTP: this.verifyOtpFromMail
        }),
      }
    );
    const result: IAPIResponse = await response.json();
    if (result.success && result.body){
      const user = result.body;
      localStorage.removeItem('filter'); //when ever login initailaly localstoreg set value must be removed bcs old filter from users and company must be removed
      localStorage.removeItem("companyFilter");
      await authStore.recordAuthAppLogin(user.auth_id, 0)
      authStore.login(user);
      checkAuthStore();
      let universityPermission = user.Apps.find(app=>app.app_id==2)

      // if (user.Verified === 1 && user.IntroCoursesComplete === 0) {
      //   window.location.replace(`${config.BASE_UNIVERSITY_URL}/landing?sessionKey=${authStore.currentUser.SessionKey}`)
      // }
      // else if (user.Verified === 1 && user.IntroCoursesComplete === 1) {
      //   window.location.replace('/dashboard')
      // }
      if (
        user.Verified === 1 &&
        user.IntroCoursesComplete === 0 &&
        universityPermission.Active
      ) {
        window.location.replace(
          `${config.BASE_UNIVERSITY_URL}/landing?sessionKey=${authStore.currentUser.SessionKey}`
        );
      } else if (
        (user.Verified === 1 && user.IntroCoursesComplete === 1) ||
        (user.Verified === 1 && !universityPermission.Active)
      ) {
        window.location.replace("/dashboard");
      } else {
        window.location.replace("/password-verify");
      }
    } else {
      // alert("otp not matched!.");
      // E-066
      this.isMatched = true;
      this.verifyOtpFromMail = "";
      this.setState({ enableVerifyBtn: true });
    }
    // E-066
    if(this.isMatched== true){
     setTimeout(() => {
       this.isMatched =  false;
     }, 3000);
    }
  };

  /**
   * #TODO E-001 handleResentOTP TMPS > 2 Step Verification
   */
  public handleResentOTP = async () => {
    this.reverseCount= 60; // E-066
    const response: Response = await fetch(
      config.BASE_URL + "/api/auth/resend_otp",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          Email: this.email,
        }),
      }
    );
    const result: IAPIResponse = await response.json();
    // E-066
    if (result) {
      this.CountFun();
      this.isSuccessAlert = true
    }
    if(this.isSuccessAlert == true){
      setTimeout(() => {
        this.isSuccessAlert = false
      }, 3000);
    }
  };

  // E-066
  public handleKeyPress(e: any) {
    if (e.key === "Enter" || e.which === 13) {
      console.log("enter key pressed");
    }
  }

  // E-066
  public handleCancelBtn = () =>{
    this.reverseCount = 10;
    clearInterval(this.cpyReverseCount);
    this.setState({ otpDialogOpen: false })
  }

  public render() {
    return (<>
      <div className="login-form">
        {/* E-066 */}
        {
          this.isSuccessAlert === true ? <AlertBar sentItem = {this.logInUserName} success ={true}/> : false
        } 
        {
           this.isMatched === true ? <AlertBar title ={"OTP is not matched. Please enter valid OTP code."} errorAlert ={true}/> : false
        }
        {
          this.combinationError === true ? <AlertBar title ={"User and password combination not found."} errorAlert ={true}/> : false
        }
        <Dialog open={this.state.afterRequestDialogOpen}>
          <DialogContent>
            <DialogContentText>
              If an account with the email address submitted exists, a link has
              been sent to the inbox.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              // tslint:disable-next-line: jsx-no-lambda
              onClick={() => this.setState({ afterRequestDialogOpen: false })}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.dialogOpen}>
          <DialogTitle>Forgot Password</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter your email and request a password reset. If an account with
              this email exists, a link to reset you password will be sent to
              your inbox.
            </DialogContentText>
          </DialogContent>

          <DialogContent>
            <MaterialTextField
              className="login-form__email"
              error={this.error}
              label="Email"
              onChange={this.handleChange("passwordResetEmail")}
              value={this.passwordResetEmail}
            />
          </DialogContent>
          <DialogActions>
            <Button
              // tslint:disable-next-line: jsx-no-lambda
              onClick={() => this.handleTokenRequest()}
              style={{ backgroundColor: "#00b33c" }}
            >
              Submit
            </Button>
            <Button
              style={{ backgroundColor: "#ff704d" }}
              // tslint:disable-next-line: jsx-no-lambda
              onClick={() => this.setState({ dialogOpen: false })}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {/* E-066 , E-066.1 E-001 TMPS > 2 Step Verification */}
        <Dialog className="dialogBox stepverification" open={this.state.otpDialogOpen} style={{borderRadius:'20px'}}>

          <DialogTitle style={{backgroundColor:'#192e5b'}}>
            <span style={{color:'white'}}>Let’s Verify Your Account</span>
          </DialogTitle>
          <DialogContent>
            <div style={{padding:'20px 0px 0px 0px'}}>
              Welcome{" "}
              <span className="welcomUserEmail">{this.logInUserName}</span>
            </div>
          </DialogContent>
          <div className="dflex">
            <span className="mailCode">
              What is the code that was emailed to you?
            </span>
          </div>
          <DialogContent style={{display:"flex", justifyContent:"space-between", alignItems:"self-end"}}>
            <div className="inputContainer">
              {/* E-066 */}
              <Input
                type="number"
                id="inp"
                className="inputFields"
                style={{ padding: "0px 50px 0px 20px" }}
                error={this.error}
                // label="Enter the OTP"
                onChange={e => this.handlOtpChange(e)}
                value={this.verifyOtpFromMail}
                maxLength={6}
                onKeyDown={(e: any) => {
                  if (e.key === "Enter" || e.which === 13) {
                    this.handleVerifyOtpToLogin();
                  }
                }}
              />
              <span>Enter the OTP</span>
            </div>
            <div>
            {
              this.reverseCount === 0 ?
               <Button
                  style={{backgroundColor:'#1c37f740'}}
                  variant="outlined"
                  className="optctsmcssbtn"
                >
                  <span style={{fontWeight: "bolder"}} onClick={this.handleResentOTP}>
                  Resend OTP
                  </span>
                </Button>
              :
                <Button
                  style={{backgroundColor:'#bedfff', cursor:'default'}}
                  variant="outlined"
                  className="optctsmcssbtn"
                >
                  <span style={{fontWeight: "bolder"}}>Expires in : {this.reverseCount} sec</span>
                </Button>
            }
            </div>
           
            </DialogContent>
          <DialogActions className="actionbtnDialog">
            <button
              // tslint:disable-next-line: jsx-no-lambda
              onClick={() => this.handleVerifyOtpToLogin()}
              className="popupBtncls"
              style={{ backgroundColor: "#00b33c" }}
              disabled={this.state.enableVerifyBtn}
            >
              Verify
            </button>
            <button
              style={{ backgroundColor: "#ff704d" }}
              onClick={this.handleCancelBtn} // E-066
              className="popupBtncls"
            >
              Cancel
            </button>
          </DialogActions>
        </Dialog>

        <div className="login-form__container" style={{borderRadius:'15px'}}>
          <Typography variant="h5" gutterBottom={true}>
            Log in
          </Typography>
          <form id="login" onSubmit={this.handleLogin}>
            <div className="login-form__text-field-container">
              <div className="row login-form__text-field">
                <MaterialTextField
                  className="login-form__email"
                  error={this.error}
                  label="Email"
                  onChange={this.handleChange("email")}
                  value={this.email}
                  required
                />
              </div>
              <div className="row login-form__text-field">
                <MaterialTextField
                  className="login-form__password"
                  error={this.error}
                  label="Password"
                  type="password"
                  onChange={this.handleChange("password")}
                  value={this.password}
                  required
                />
              </div>
            </div>
            <div className="login-form__btns" />
            <div className="login-form__btn">
              <Button
                style={{ backgroundColor: "#00c079",color:'white', fontWeight:'bolder' }}
                fullWidth={true}
                variant="outlined"
                size="large"
                type="submit"
              >
                Log in
              </Button>
            </div>
            <div className="login-form__btn">
              <Button
                fullWidth={true}
                variant="outlined"
                size="large"
                style={{ backgroundColor: "#192e5b", color:'white', fontWeight:'bolder', marginTop:"10px"}}
                // tslint:disable-next-line: jsx-no-lambda
                onClick={() => this.setState({ dialogOpen: true })}
              >
                Forgot Password
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>);
  }
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/modules/login/components/LoginForm.tsx